import { render } from "./jobContact.vue?vue&type=template&id=401ffdde"
import script from "./jobContact.vue?vue&type=script&lang=js"
export * from "./jobContact.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__